import ReactPlayer from 'react-player/vimeo'
import { handleError } from '@velasca/utils/handle-error'
import { PlayerWrapper } from './VimeoVideo.styles'
import type { VimeoVideoProps } from './VimeoVideo.types'

const resetFocusToOuterDocument = () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur()
  }
}

export const VimeoVideo = ({
  url,
  aspectRatio,
}: VimeoVideoProps): JSX.Element => {
  return (
    <PlayerWrapper aspectRatio={aspectRatio}>
      <ReactPlayer
        controls
        playing
        playsinline
        height="100%"
        width="100%"
        url={url}
        onError={handleError}
        onPause={resetFocusToOuterDocument}
        onPlay={resetFocusToOuterDocument}
      />
    </PlayerWrapper>
  )
}
